module.exports = __webpack_public_path__ + "img/galeria-aquicultura-4.9cc28e62.jpg";